export default {"src":"/_next/static/media/arrowforward.dd79ab53.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};